export default __webpack_public_path__ + "static/media/Raleway-Light.f25e9b3a.ttf";